import { axiosPrivate } from 'shared/api';
import { IExam } from 'features/cost-analysis/exams/types';
import { ExportableResourceService } from 'shared/services/ExportableResourceService';

class ExamService extends ExportableResourceService<IExam> {
  constructor() {
    super('exams');
  }
  canDelete = true;
  canBulkDelete = true;

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };

  assignProduct = async (examId: number, product: number) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/${examId}/assign_product/`, {
      products: [{ product }]
    });
    return res.data;
  };

  assignProductWarehouse = async (examId: number, productWarehouseId: number) => {
    const res = await axiosPrivate.post(
      `${this.modulePrefix}/${examId}/assign-product-warehouse/`,
      {
        product_warehouses: [{ product_warehouse: productWarehouseId }]
      }
    );
    return res.data;
  };
}

export const examService = new ExamService();
